import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const RecordedClassesPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // State for filters
  const [searchQuery, setSearchQuery] = useState("");
  const [subjectFilter, setSubjectFilter] = useState("all");
  const [typeFilter, setTypeFilter] = useState("all");
  const [sortOption, setSortOption] = useState("newest");
  const [showFilters, setShowFilters] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const classesPerPage = 9;

  // Mock data for recorded classes
  const recordedClasses = [
    {
      id: 1,
      title: "Nagaland State Formation",
      instructor: "Dr. Imtisunep Longchar",
      duration: "2h 15m",
      date: "March 10, 2025",
      subject: "History",
      description:
        "Detailed analysis of the events leading to the formation of Nagaland state, including the role of Naga National Council and the 16-Point Agreement.",
      image: "/images/history-formation.jpg",
      watchLink: "/class-details/1",
      type: "foundation",
      popular: true,
      rating: 4.8,
      views: 342,
    },
    {
      id: 2,
      title: "Administrative Structure of Nagaland",
      instructor: "Prof. Kezhokhoto Savi",
      duration: "1h 45m",
      date: "March 5, 2025",
      subject: "Administration",
      description:
        "Comprehensive overview of Nagaland's administrative setup, roles of Deputy Commissioners, and the dual system of administration.",
      image: "/images/admin-structure.jpg",
      watchLink: "/class-details/2",
      type: "mains",
      popular: false,
      rating: 4.6,
      views: 215,
    },
    {
      id: 3,
      title: "Biodiversity of Nagaland",
      instructor: "Dr. Bendangsenla Jamir",
      duration: "2h 30m",
      date: "February 28, 2025",
      subject: "Environment",
      description:
        "Exploration of Nagaland's rich biodiversity, conservation challenges, and traditional ecological knowledge systems.",
      image: "/images/biodiversity.jpg",
      watchLink: "/class-details/3",
      type: "foundation",
      popular: false,
      rating: 4.7,
      views: 198,
    },
    {
      id: 4,
      title: "Nagaland Culture & Traditions",
      instructor: "Prof. Ketholenuo Mer",
      duration: "3h 10m",
      date: "February 23, 2025",
      subject: "Culture",
      description:
        "In-depth study of Naga tribes, their cultural practices, festivals, and traditional governance systems relevant for NPSC examinations.",
      image: "/images/culture-traditions.jpg",
      watchLink: "/class-details/4",
      type: "mains",
      popular: true,
      rating: 4.9,
      views: 456,
    },
    {
      id: 5,
      title: "Current Affairs: Nagaland Special",
      instructor: "Dr. Rosemary Dzüvichü",
      duration: "1h 50m",
      date: "February 20, 2025",
      subject: "Current Affairs",
      description:
        "Analysis of recent developments in Nagaland politics, economy, and society with a focus on NPSC-relevant topics.",
      image: "/images/current-affairs.jpg",
      watchLink: "/class-details/5",
      type: "prelims",
      popular: true,
      rating: 4.5,
      views: 387,
    },
    {
      id: 6,
      title: "Economics of Northeast India",
      instructor: "Dr. Rosemary Dzüvichü",
      duration: "2h 25m",
      date: "February 15, 2025",
      subject: "Economy",
      description:
        "Comparative study of economic development across Northeast states with special emphasis on Nagaland's economic challenges and opportunities.",
      image: "/images/economics-northeast.jpg",
      watchLink: "/class-details/6",
      type: "prelims",
      popular: false,
      rating: 4.3,
      views: 165,
    },
    {
      id: 7,
      title: "Nagaland Peace Process",
      instructor: "Dr. Imtisunep Longchar",
      duration: "2h 40m",
      date: "February 10, 2025",
      subject: "Political Science",
      description:
        "Historical overview and current status of the Naga peace process, examining various agreements and their implications.",
      image: "/images/peace-process.jpg",
      watchLink: "/class-details/7",
      type: "mains",
      popular: false,
      rating: 4.8,
      views: 210,
    },
    {
      id: 8,
      title: "NPSC Prelims Approach & Strategy",
      instructor: "Prof. Kezhokhoto Savi",
      duration: "2h 00m",
      date: "February 5, 2025",
      subject: "Exam Strategy",
      description:
        "Comprehensive guidance on approaching NPSC Prelims, including time management, question selection, and elimination techniques.",
      image: "/images/prelims-strategy.jpg",
      watchLink: "/class-details/8",
      type: "prelims",
      popular: true,
      rating: 4.9,
      views: 520,
    },
    {
      id: 9,
      title: "Geography of Nagaland",
      instructor: "Prof. Ketholenuo Mer",
      duration: "2h 35m",
      date: "January 28, 2025",
      subject: "Geography",
      description:
        "Detailed exploration of Nagaland's physiography, climate, natural resources, and economic geography for NPSC preparation.",
      image: "/images/nagaland-geography.jpg",
      watchLink: "/class-details/9",
      type: "foundation",
      popular: false,
      rating: 4.7,
      views: 245,
    },
    {
      id: 10,
      title: "Naga Customary Laws",
      instructor: "Prof. Kezhokhoto Savi",
      duration: "1h 55m",
      date: "January 22, 2025",
      subject: "Law",
      description:
        "In-depth analysis of Naga customary laws, their constitutional status, and their role in modern governance systems.",
      image: "/images/customary-laws.jpg",
      watchLink: "/class-details/10",
      type: "mains",
      popular: false,
      rating: 4.6,
      views: 178,
    },
    {
      id: 11,
      title: "Art and Architecture of Nagaland",
      instructor: "Dr. Bendangsenla Jamir",
      duration: "1h 40m",
      date: "January 15, 2025",
      subject: "Culture",
      description:
        "Comprehensive study of traditional Naga art forms, architecture, crafts, and their cultural significance.",
      image: "/images/naga-art.jpg",
      watchLink: "/class-details/11",
      type: "foundation",
      popular: false,
      rating: 4.5,
      views: 156,
    },
    {
      id: 12,
      title: "Answer Writing for NPSC Mains",
      instructor: "Dr. Rosemary Dzüvichü",
      duration: "2h 20m",
      date: "January 10, 2025",
      subject: "Exam Strategy",
      description:
        "Techniques and strategies for effective answer writing in NPSC Mains examination with examples and practice exercises.",
      image: "/images/answer-writing.jpg",
      watchLink: "/class-details/12",
      type: "mains",
      popular: true,
      rating: 4.9,
      views: 432,
    },
  ];

  // Extract unique subjects for filter dropdown
  const subjects = [...new Set(recordedClasses.map((cls) => cls.subject))];

  // Filter classes based on search and filters
  const filterClasses = () => {
    return recordedClasses.filter((cls) => {
      const matchesSearch =
        cls.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
        cls.description.toLowerCase().includes(searchQuery.toLowerCase()) ||
        cls.instructor.toLowerCase().includes(searchQuery.toLowerCase());
      const matchesSubject =
        subjectFilter === "all" || cls.subject === subjectFilter;
      const matchesType = typeFilter === "all" || cls.type === typeFilter;

      return matchesSearch && matchesSubject && matchesType;
    });
  };

  // Sort filtered classes
  const sortClasses = (classes) => {
    switch (sortOption) {
      case "newest":
        return [...classes].sort((a, b) => new Date(b.date) - new Date(a.date));
      case "oldest":
        return [...classes].sort((a, b) => new Date(a.date) - new Date(b.date));
      case "rating":
        return [...classes].sort((a, b) => b.rating - a.rating);
      case "popularity":
        return [...classes].sort((a, b) => b.views - a.views);
      case "duration-asc":
        return [...classes].sort((a, b) => {
          const durationA =
            parseInt(a.duration.split("h")[0]) * 60 +
            parseInt(a.duration.split("h")[1].replace("m", "").trim());
          const durationB =
            parseInt(b.duration.split("h")[0]) * 60 +
            parseInt(b.duration.split("h")[1].replace("m", "").trim());
          return durationA - durationB;
        });
      case "duration-desc":
        return [...classes].sort((a, b) => {
          const durationA =
            parseInt(a.duration.split("h")[0]) * 60 +
            parseInt(a.duration.split("h")[1].replace("m", "").trim());
          const durationB =
            parseInt(b.duration.split("h")[0]) * 60 +
            parseInt(b.duration.split("h")[1].replace("m", "").trim());
          return durationB - durationA;
        });
      default:
        return classes;
    }
  };

  const filteredClasses = filterClasses();
  const sortedClasses = sortClasses(filteredClasses);

  // Pagination
  const indexOfLastClass = currentPage * classesPerPage;
  const indexOfFirstClass = indexOfLastClass - classesPerPage;
  const currentClasses = sortedClasses.slice(
    indexOfFirstClass,
    indexOfLastClass
  );
  const totalPages = Math.ceil(sortedClasses.length / classesPerPage);

  // Popular classes
  const popularClasses = recordedClasses
    .filter((cls) => cls.popular)
    .slice(0, 4);

  return (
    <div className="pt-20">
      {/* Hero Section */}
      <section className="relative bg-gray-900 text-white">
        <div className="absolute inset-0">
          <div className="absolute inset-0 bg-gray-900 opacity-90"></div>
          <div className="absolute inset-0 bg-[url('https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRiqn5jXhC1CTq8isbIwTTte77VL0U7zhlBwQ&s')] opacity-10 bg-cover bg-center"></div>
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
          <div className="max-w-3xl">
            <motion.h1
              className="text-4xl md:text-5xl font-extrabold tracking-tight mb-6"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
            >
              NPSC Recorded Classes Library
            </motion.h1>
            <motion.p
              className="text-lg md:text-xl mb-8 text-gray-200"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.1 }}
            >
              Access our comprehensive library of high-quality recorded classes.
              Learn at your own pace with content tailored specifically for NPSC
              preparation.
            </motion.p>
            <motion.div
              className="relative"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
            >
              <div className="relative">
                <input
                  type="text"
                  className="block w-full rounded-lg border-0 py-4 pl-12 pr-4 text-gray-900 shadow-md placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm"
                  placeholder="Search for classes, topics, or instructors..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
                <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                  <svg
                    className="w-6 h-6 text-gray-500"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                    />
                  </svg>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-12 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mb-8 flex flex-col md:flex-row justify-between items-start md:items-center">
            <h2 className="text-2xl font-bold text-gray-900 mb-4 md:mb-0">
              {sortedClasses.length} Classes Available
            </h2>
            <div className="flex flex-col sm:flex-row space-y-3 sm:space-y-0 sm:space-x-3">
              <button
                onClick={() => setShowFilters(!showFilters)}
                className="inline-flex items-center justify-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50"
              >
                <svg
                  className="w-4 h-4 mr-2"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"
                  />
                </svg>
                {showFilters ? "Hide Filters" : "Show Filters"}
              </button>
              <div className="flex items-center space-x-2">
                <label
                  htmlFor="sort"
                  className="text-sm font-medium text-gray-700"
                >
                  Sort by:
                </label>
                <select
                  id="sort"
                  className="block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                  value={sortOption}
                  onChange={(e) => setSortOption(e.target.value)}
                >
                  <option value="newest">Newest First</option>
                  <option value="oldest">Oldest First</option>
                  <option value="rating">Highest Rated</option>
                  <option value="popularity">Most Viewed</option>
                  <option value="duration-asc">Shortest First</option>
                  <option value="duration-desc">Longest First</option>
                </select>
              </div>
            </div>
          </div>

          {/* Filters Panel */}
          {showFilters && (
            <motion.div
              initial={{ opacity: 0, height: 0 }}
              animate={{ opacity: 1, height: "auto" }}
              exit={{ opacity: 0, height: 0 }}
              transition={{ duration: 0.3 }}
              className="bg-gray-50 rounded-lg p-6 mb-8"
            >
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                <div>
                  <label
                    htmlFor="subject-filter"
                    className="block text-sm font-medium text-gray-700 mb-1"
                  >
                    Filter by Subject
                  </label>
                  <select
                    id="subject-filter"
                    className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
                    value={subjectFilter}
                    onChange={(e) => setSubjectFilter(e.target.value)}
                  >
                    <option value="all">All Subjects</option>
                    {subjects.map((subject) => (
                      <option key={subject} value={subject}>
                        {subject}
                      </option>
                    ))}
                  </select>
                </div>
                <div>
                  <label
                    htmlFor="type-filter"
                    className="block text-sm font-medium text-gray-700 mb-1"
                  >
                    Filter by Level
                  </label>
                  <select
                    id="type-filter"
                    className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
                    value={typeFilter}
                    onChange={(e) => setTypeFilter(e.target.value)}
                  >
                    <option value="all">All Levels</option>
                    <option value="foundation">Foundation</option>
                    <option value="prelims">Prelims</option>
                    <option value="mains">Mains</option>
                  </select>
                </div>
                <div className="lg:col-span-2">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Quick Filters
                  </label>
                  <div className="flex flex-wrap gap-2">
                    <button
                      onClick={() => {
                        setTypeFilter("foundation");
                        setSortOption("newest");
                      }}
                      className="inline-flex items-center px-3 py-1.5 border border-gray-300 rounded-full text-xs font-medium bg-white text-gray-700 hover:bg-gray-50"
                    >
                      Foundation Classes
                    </button>
                    <button
                      onClick={() => {
                        setSortOption("rating");
                      }}
                      className="inline-flex items-center px-3 py-1.5 border border-gray-300 rounded-full text-xs font-medium bg-white text-gray-700 hover:bg-gray-50"
                    >
                      Top Rated
                    </button>
                    <button
                      onClick={() => {
                        setSortOption("popularity");
                      }}
                      className="inline-flex items-center px-3 py-1.5 border border-gray-300 rounded-full text-xs font-medium bg-white text-gray-700 hover:bg-gray-50"
                    >
                      Most Popular
                    </button>
                    <button
                      onClick={() => {
                        setTypeFilter("prelims");
                      }}
                      className="inline-flex items-center px-3 py-1.5 border border-gray-300 rounded-full text-xs font-medium bg-white text-gray-700 hover:bg-gray-50"
                    >
                      Prelims Focus
                    </button>
                    <button
                      onClick={() => {
                        setTypeFilter("mains");
                      }}
                      className="inline-flex items-center px-3 py-1.5 border border-gray-300 rounded-full text-xs font-medium bg-white text-gray-700 hover:bg-gray-50"
                    >
                      Mains Focus
                    </button>
                    <button
                      onClick={() => {
                        setSubjectFilter("Exam Strategy");
                      }}
                      className="inline-flex items-center px-3 py-1.5 border border-gray-300 rounded-full text-xs font-medium bg-white text-gray-700 hover:bg-gray-50"
                    >
                      Exam Strategy
                    </button>
                  </div>
                </div>
              </div>
              <div className="mt-4 flex justify-end">
                <button
                  onClick={() => {
                    setSubjectFilter("all");
                    setTypeFilter("all");
                    setSortOption("newest");
                    setSearchQuery("");
                  }}
                  className="text-sm text-indigo-600 hover:text-indigo-800 font-medium"
                >
                  Reset All Filters
                </button>
              </div>
            </motion.div>
          )}

          {/* Popular Classes (only shown when no filters are applied) */}
          {!searchQuery && subjectFilter === "all" && typeFilter === "all" && (
            <div className="mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mb-6">
                Popular Classes
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                {popularClasses.map((popularClass) => (
                  <motion.div
                    key={popularClass.id}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.3 }}
                    className="bg-white border border-gray-200 rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-all duration-300"
                  >
                    <div className="relative">
                      <img
                        src={popularClass.image || "/images/placeholder.jpg"}
                        alt={popularClass.title}
                        className="w-full h-40 object-cover"
                      />
                      <div className="absolute inset-0 flex items-center justify-center">
                        <div className="w-12 h-12 bg-white/80 rounded-full flex items-center justify-center">
                          <svg
                            className="w-6 h-6 text-indigo-600"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                          >
                            <path d="M4 5h3v10H4V5zm12 0v10l-9-5 9-5z" />
                          </svg>
                        </div>
                      </div>
                      <div className="absolute top-0 right-0 m-2">
                        <span className="bg-yellow-100 text-yellow-800 text-xs font-medium px-2.5 py-0.5 rounded-full">
                          Popular
                        </span>
                      </div>
                      <div className="absolute bottom-0 left-0 m-2">
                        <span className="bg-black/60 text-white text-xs font-medium px-2.5 py-0.5 rounded">
                          {popularClass.duration}
                        </span>
                      </div>
                    </div>
                    <div className="p-4">
                      <div className="flex justify-between mb-1">
                        <span
                          className={`text-xs font-medium px-2 py-0.5 rounded ${
                            popularClass.type === "foundation"
                              ? "bg-green-100 text-green-800"
                              : popularClass.type === "prelims"
                              ? "bg-blue-100 text-blue-800"
                              : "bg-purple-100 text-purple-800"
                          }`}
                        >
                          {popularClass.type.charAt(0).toUpperCase() +
                            popularClass.type.slice(1)}
                        </span>
                        <div className="flex items-center">
                          <svg
                            className="w-4 h-4 text-yellow-400"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                          >
                            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                          </svg>
                          <span className="text-xs ml-1 text-gray-600">
                            {popularClass.rating}
                          </span>
                        </div>
                      </div>
                      <h3 className="text-lg font-bold text-gray-900 mb-1 line-clamp-1">
                        {popularClass.title}
                      </h3>
                      <p className="text-sm text-gray-600 mb-2">
                        {popularClass.instructor}
                      </p>
                      <Link
                        to={popularClass.watchLink}
                        className="text-indigo-600 hover:text-indigo-800 text-sm font-medium flex items-center"
                      >
                        <span>Watch Now</span>
                        <svg
                          className="w-4 h-4 ml-1"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M17 8l4 4m0 0l-4 4m4-4H3"
                          />
                        </svg>
                      </Link>
                    </div>
                  </motion.div>
                ))}
              </div>
            </div>
          )}

          {/* Classes Grid */}
          {currentClasses.length === 0 ? (
            <div className="text-center py-16">
              <svg
                className="w-16 h-16 text-gray-300 mx-auto mb-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z"
                />
              </svg>
              <h3 className="text-lg font-medium text-gray-900 mb-1">
                No classes found
              </h3>
              <p className="text-gray-600 mb-4">
                Try adjusting your search or filter criteria
              </p>
              <button
                onClick={() => {
                  setSubjectFilter("all");
                  setTypeFilter("all");
                  setSortOption("newest");
                  setSearchQuery("");
                }}
                className="inline-flex items-center justify-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700"
              >
                Reset Filters
              </button>
            </div>
          ) : (
            <>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {currentClasses.map((recordedClass) => (
                  <motion.div
                    key={recordedClass.id}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.3 }}
                    className="bg-white border border-gray-200 rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-all duration-300"
                  >
                    <div className="relative">
                      <img
                        src={recordedClass.image || "/images/placeholder.jpg"}
                        alt={recordedClass.title}
                        className="w-full h-48 object-cover"
                      />
                      <div className="absolute inset-0 flex items-center justify-center">
                        <div className="w-14 h-14 bg-white/80 rounded-full flex items-center justify-center">
                          <svg
                            className="w-8 h-8 text-indigo-600"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                          >
                            <path d="M4 5h3v10H4V5zm12 0v10l-9-5 9-5z" />
                          </svg>
                        </div>
                      </div>
                      <div className="absolute top-2 right-2 flex space-x-2">
                        <span className="bg-indigo-100 text-indigo-800 text-xs font-medium px-2.5 py-0.5 rounded">
                          {recordedClass.subject}
                        </span>
                        {recordedClass.popular && (
                          <span className="bg-yellow-100 text-yellow-800 text-xs font-medium px-2.5 py-0.5 rounded-full">
                            Popular
                          </span>
                        )}
                      </div>
                      <div className="absolute bottom-2 left-2 bg-black/60 text-white text-xs font-medium px-2.5 py-0.5 rounded">
                        {recordedClass.duration}
                      </div>
                    </div>
                    <div className="p-5">
                      <div className="flex justify-between items-center mb-2">
                        <span
                          className={`text-xs font-medium px-2.5 py-0.5 rounded ${
                            recordedClass.type === "foundation"
                              ? "bg-green-100 text-green-800"
                              : recordedClass.type === "prelims"
                              ? "bg-blue-100 text-blue-800"
                              : "bg-purple-100 text-purple-800"
                          }`}
                        >
                          {recordedClass.type.charAt(0).toUpperCase() +
                            recordedClass.type.slice(1)}
                        </span>
                        <div className="flex items-center">
                          <svg
                            className="w-4 h-4 text-yellow-400"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                          >
                            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                          </svg>
                          <span className="text-xs ml-1 text-gray-600">
                            {recordedClass.rating}
                          </span>
                        </div>
                      </div>
                      <h3 className="text-lg font-bold text-gray-900 mb-2">
                        {recordedClass.title}
                      </h3>
                      <p className="text-gray-600 text-sm mb-4 line-clamp-2">
                        {recordedClass.description}
                      </p>
                      <div className="flex items-center mb-4">
                        <svg
                          className="w-4 h-4 mr-1 text-gray-600"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                          />
                        </svg>
                        <p className="text-sm text-gray-700">
                          {recordedClass.instructor}
                        </p>
                      </div>
                      <div className="flex justify-between items-center">
                        <div className="flex items-center text-xs text-gray-500">
                          <svg
                            className="w-4 h-4 mr-1"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                            />
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                            />
                          </svg>
                          <span>{recordedClass.views} views</span>
                        </div>
                        <Link
                          to={recordedClass.watchLink}
                          className="inline-flex items-center text-indigo-600 hover:text-indigo-800 font-medium"
                        >
                          <span>Watch Now</span>
                          <svg
                            className="w-4 h-4 ml-1"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M17 8l4 4m0 0l-4 4m4-4H3"
                            />
                          </svg>
                        </Link>
                      </div>
                    </div>
                  </motion.div>
                ))}
              </div>

              {/* Pagination */}
              {totalPages > 1 && (
                <div className="flex justify-center mt-10">
                  <nav className="flex items-center space-x-1">
                    <button
                      onClick={() =>
                        setCurrentPage((prev) => Math.max(prev - 1, 1))
                      }
                      disabled={currentPage === 1}
                      className={`px-3 py-2 rounded-md text-sm font-medium ${
                        currentPage === 1
                          ? "text-gray-400 cursor-not-allowed"
                          : "text-gray-500 bg-white border border-gray-300 hover:bg-gray-50"
                      }`}
                    >
                      Previous
                    </button>

                    {[...Array(totalPages)].map((_, i) => (
                      <button
                        key={i}
                        onClick={() => setCurrentPage(i + 1)}
                        className={`px-3 py-2 rounded-md text-sm font-medium ${
                          currentPage === i + 1
                            ? "text-white bg-indigo-600 border border-indigo-600"
                            : "text-gray-700 bg-white border border-gray-300 hover:bg-gray-50"
                        }`}
                      >
                        {i + 1}
                      </button>
                    ))}

                    <button
                      onClick={() =>
                        setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                      }
                      disabled={currentPage === totalPages}
                      className={`px-3 py-2 rounded-md text-sm font-medium ${
                        currentPage === totalPages
                          ? "text-gray-400 cursor-not-allowed"
                          : "text-gray-700 bg-white border border-gray-300 hover:bg-gray-50"
                      }`}
                    >
                      Next
                    </button>
                  </nav>
                </div>
              )}
            </>
          )}
        </div>
      </section>

      {/* Subject Categories Section */}
      <section className="py-12 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center">
            Browse by Subject
          </h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            <Link
              to="/recorded-classes?subject=History"
              className="group flex flex-col items-center p-6 bg-white rounded-lg shadow-md hover:shadow-lg transition-all duration-300"
            >
              <div className="w-16 h-16 bg-indigo-100 rounded-full flex items-center justify-center mb-4 group-hover:bg-indigo-200 transition-colors duration-300">
                <svg
                  className="w-8 h-8 text-indigo-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"
                  />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">History</h3>
              <p className="text-gray-600 text-center mb-4">
                Nagaland's historical evolution, key events, and movements
              </p>
              <span className="text-indigo-600 font-medium flex items-center group-hover:text-indigo-800">
                View Classes
                <svg
                  className="w-4 h-4 ml-1 transform group-hover:translate-x-1 transition-transform duration-300"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M17 8l4 4m0 0l-4 4m4-4H3"
                  />
                </svg>
              </span>
            </Link>

            <Link
              to="/recorded-classes?subject=Administration"
              className="group flex flex-col items-center p-6 bg-white rounded-lg shadow-md hover:shadow-lg transition-all duration-300"
            >
              <div className="w-16 h-16 bg-indigo-100 rounded-full flex items-center justify-center mb-4 group-hover:bg-indigo-200 transition-colors duration-300">
                <svg
                  className="w-8 h-8 text-indigo-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                  />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">
                Administration
              </h3>
              <p className="text-gray-600 text-center mb-4">
                Governance structures, policies, and administrative systems
              </p>
              <span className="text-indigo-600 font-medium flex items-center group-hover:text-indigo-800">
                View Classes
                <svg
                  className="w-4 h-4 ml-1 transform group-hover:translate-x-1 transition-transform duration-300"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M17 8l4 4m0 0l-4 4m4-4H3"
                  />
                </svg>
              </span>
            </Link>

            <Link
              to="/recorded-classes?subject=Culture"
              className="group flex flex-col items-center p-6 bg-white rounded-lg shadow-md hover:shadow-lg transition-all duration-300"
            >
              <div className="w-16 h-16 bg-indigo-100 rounded-full flex items-center justify-center mb-4 group-hover:bg-indigo-200 transition-colors duration-300">
                <svg
                  className="w-8 h-8 text-indigo-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Culture</h3>
              <p className="text-gray-600 text-center mb-4">
                Tribal traditions, festivals, arts, and cultural heritage
              </p>
              <span className="text-indigo-600 font-medium flex items-center group-hover:text-indigo-800">
                View Classes
                <svg
                  className="w-4 h-4 ml-1 transform group-hover:translate-x-1 transition-transform duration-300"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M17 8l4 4m0 0l-4 4m4-4H3"
                  />
                </svg>
              </span>
            </Link>

            <Link
              to="/recorded-classes?subject=Exam Strategy"
              className="group flex flex-col items-center p-6 bg-white rounded-lg shadow-md hover:shadow-lg transition-all duration-300"
            >
              <div className="w-16 h-16 bg-indigo-100 rounded-full flex items-center justify-center mb-4 group-hover:bg-indigo-200 transition-colors duration-300">
                <svg
                  className="w-8 h-8 text-indigo-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"
                  />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">
                Exam Strategy
              </h3>
              <p className="text-gray-600 text-center mb-4">
                Preparation techniques, answer writing, and exam approach
              </p>
              <span className="text-indigo-600 font-medium flex items-center group-hover:text-indigo-800">
                View Classes
                <svg
                  className="w-4 h-4 ml-1 transform group-hover:translate-x-1 transition-transform duration-300"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M17 8l4 4m0 0l-4 4m4-4H3"
                  />
                </svg>
              </span>
            </Link>
          </div>

          <div className="text-center mt-8">
            <Link
              to="/subjects"
              className="inline-flex items-center text-indigo-600 hover:text-indigo-800 font-medium"
            >
              <span>View All Subjects</span>
              <svg
                className="w-4 h-4 ml-1"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M17 8l4 4m0 0l-4 4m4-4H3"
                />
              </svg>
            </Link>
          </div>
        </div>
      </section>

      {/* Study Plans Section */}
      <section className="py-12 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Curated Study Plans
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Follow our expert-designed learning paths to efficiently prepare
              for different stages of the NPSC examination.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white border border-gray-200 rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-all duration-300">
              <div className="h-3 bg-green-500"></div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-2">
                  Foundation Course
                </h3>
                <p className="text-gray-600 mb-4">
                  Build a strong foundation with essential concepts and
                  knowledge areas for NPSC preparation.
                </p>
                <div className="flex items-center mb-4">
                  <svg
                    className="w-5 h-5 text-gray-500 mr-2"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                  <span className="text-gray-600">48 hours of content</span>
                </div>
                <div className="flex items-center mb-4">
                  <svg
                    className="w-5 h-5 text-gray-500 mr-2"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"
                    />
                  </svg>
                  <span className="text-gray-600">Ideal for beginners</span>
                </div>
                <div className="flex items-center mb-6">
                  <svg
                    className="w-5 h-5 text-gray-500 mr-2"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"
                    />
                  </svg>
                  <span className="text-gray-600">16 curated classes</span>
                </div>
                <Link
                  to="/study-plan/foundation"
                  className="block w-full text-center py-3 bg-green-600 hover:bg-green-700 text-white font-medium rounded-md transition-colors duration-300"
                >
                  View Study Plan
                </Link>
              </div>
            </div>

            <div className="bg-white border border-gray-200 rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-all duration-300">
              <div className="h-3 bg-blue-500"></div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-2">
                  Prelims Preparation
                </h3>
                <p className="text-gray-600 mb-4">
                  Focused preparation for NPSC Preliminary examination with
                  subject-specific content and strategies.
                </p>
                <div className="flex items-center mb-4">
                  <svg
                    className="w-5 h-5 text-gray-500 mr-2"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                  <span className="text-gray-600">64 hours of content</span>
                </div>
                <div className="flex items-center mb-4">
                  <svg
                    className="w-5 h-5 text-gray-500 mr-2"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"
                    />
                  </svg>
                  <span className="text-gray-600">Includes MCQ practice</span>
                </div>
                <div className="flex items-center mb-6">
                  <svg
                    className="w-5 h-5 text-gray-500 mr-2"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"
                    />
                  </svg>
                  <span className="text-gray-600">24 curated classes</span>
                </div>
                <Link
                  to="/study-plan/prelims"
                  className="block w-full text-center py-3 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-md transition-colors duration-300"
                >
                  View Study Plan
                </Link>
              </div>
            </div>

            <div className="bg-white border border-gray-200 rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-all duration-300">
              <div className="h-3 bg-purple-500"></div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-2">
                  Mains Mastery
                </h3>
                <p className="text-gray-600 mb-4">
                  Comprehensive preparation for NPSC Mains examination with
                  emphasis on answer writing and analytical skills.
                </p>
                <div className="flex items-center mb-4">
                  <svg
                    className="w-5 h-5 text-gray-500 mr-2"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                  <span className="text-gray-600">72 hours of content</span>
                </div>
                <div className="flex items-center mb-4">
                  <svg
                    className="w-5 h-5 text-gray-500 mr-2"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"
                    />
                  </svg>
                  <span className="text-gray-600">Answer writing focus</span>
                </div>
                <div className="flex items-center mb-6">
                  <svg
                    className="w-5 h-5 text-gray-500 mr-2"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"
                    />
                  </svg>
                  <span className="text-gray-600">30 curated classes</span>
                </div>
                <Link
                  to="/study-plan/mains"
                  className="block w-full text-center py-3 bg-purple-600 hover:bg-purple-700 text-white font-medium rounded-md transition-colors duration-300"
                >
                  View Study Plan
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="py-12 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              What Our Students Say
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Hear from successful NPSC aspirants who used our recorded classes
              for their preparation.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              className="bg-white p-6 rounded-lg border border-gray-200 shadow-md relative"
            >
              <svg
                className="w-12 h-12 text-indigo-100 absolute top-4 left-4"
                fill="currentColor"
                viewBox="0 0 32 32"
              >
                <path d="M9.352 4C4.456 7.456 1 13.12 1 19.36c0 5.088 3.072 8.064 6.624 8.064 3.36 0 5.856-2.688 5.856-5.856 0-3.168-2.208-5.472-5.088-5.472-.576 0-1.344.096-1.536.192.48-3.264 3.552-7.104 6.624-9.024L9.352 4zm16.512 0c-4.8 3.456-8.256 9.12-8.256 15.36 0 5.088 3.072 8.064 6.624 8.064 3.264 0 5.856-2.688 5.856-5.856 0-3.168-2.304-5.472-5.184-5.472-.576 0-1.248.096-1.44.192.48-3.264 3.456-7.104 6.528-9.024L25.864 4z" />
              </svg>
              <p className="italic text-gray-600 mb-6 pt-6">
                "The recorded classes were a game-changer for my NPSC
                preparation. I could study at my own pace and revisit complex
                topics multiple times. The quality of instruction was
                exceptional."
              </p>
              <div className="flex items-center">
                <div className="mr-4 h-12 w-12 rounded-full overflow-hidden bg-gray-300">
                  <img
                    src="/images/testimonial-1.jpg"
                    alt="Zhimomi Achumi"
                    className="h-full w-full object-cover"
                  />
                </div>
                <div>
                  <h3 className="font-bold text-lg text-gray-900">
                    Zhimomi Achumi
                  </h3>
                  <p className="text-indigo-600 font-medium">
                    NPSC 2022 Rank 8
                  </p>
                </div>
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.1 }}
              className="bg-white p-6 rounded-lg border border-gray-200 shadow-md relative"
            >
              <svg
                className="w-12 h-12 text-indigo-100 absolute top-4 left-4"
                fill="currentColor"
                viewBox="0 0 32 32"
              >
                <path d="M9.352 4C4.456 7.456 1 13.12 1 19.36c0 5.088 3.072 8.064 6.624 8.064 3.36 0 5.856-2.688 5.856-5.856 0-3.168-2.208-5.472-5.088-5.472-.576 0-1.344.096-1.536.192.48-3.264 3.552-7.104 6.624-9.024L9.352 4zm16.512 0c-4.8 3.456-8.256 9.12-8.256 15.36 0 5.088 3.072 8.064 6.624 8.064 3.264 0 5.856-2.688 5.856-5.856 0-3.168-2.304-5.472-5.184-5.472-.576 0-1.248.096-1.44.192.48-3.264 3.456-7.104 6.528-9.024L25.864 4z" />
              </svg>
              <p className="italic text-gray-600 mb-6 pt-6">
                "I was working full-time while preparing for NPSC. The
                flexibility of the recorded classes made it possible for me to
                manage both. The faculty's approach to Nagaland-specific topics
                was particularly helpful."
              </p>
              <div className="flex items-center">
                <div className="mr-4 h-12 w-12 rounded-full overflow-hidden bg-gray-300">
                  <img
                    src="/images/testimonial-2.jpg"
                    alt="Alemla Imsong"
                    className="h-full w-full object-cover"
                  />
                </div>
                <div>
                  <h3 className="font-bold text-lg text-gray-900">
                    Alemla Imsong
                  </h3>
                  <p className="text-indigo-600 font-medium">
                    NPSC 2023 Rank 12
                  </p>
                </div>
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
              className="bg-white p-6 rounded-lg border border-gray-200 shadow-md relative"
            >
              <svg
                className="w-12 h-12 text-indigo-100 absolute top-4 left-4"
                fill="currentColor"
                viewBox="0 0 32 32"
              >
                <path d="M9.352 4C4.456 7.456 1 13.12 1 19.36c0 5.088 3.072 8.064 6.624 8.064 3.36 0 5.856-2.688 5.856-5.856 0-3.168-2.208-5.472-5.088-5.472-.576 0-1.344.096-1.536.192.48-3.264 3.552-7.104 6.624-9.024L9.352 4zm16.512 0c-4.8 3.456-8.256 9.12-8.256 15.36 0 5.088 3.072 8.064 6.624 8.064 3.264 0 5.856-2.688 5.856-5.856 0-3.168-2.304-5.472-5.184-5.472-.576 0-1.248.096-1.44.192.48-3.264 3.456-7.104 6.528-9.024L25.864 4z" />
              </svg>
              <p className="italic text-gray-600 mb-6 pt-6">
                "The recorded classes library is incredibly comprehensive. The
                instructors explain complex topics in a simple manner, and the
                Nagaland-specific focus is exactly what I needed for my NPSC
                preparation."
              </p>
              <div className="flex items-center">
                <div className="mr-4 h-12 w-12 rounded-full overflow-hidden bg-gray-300">
                  <img
                    src="/images/testimonial-3.jpg"
                    alt="Khrienuo Metha"
                    className="h-full w-full object-cover"
                  />
                </div>
                <div>
                  <h3 className="font-bold text-lg text-gray-900">
                    Khrienuo Metha
                  </h3>
                  <p className="text-indigo-600 font-medium">
                    NPSC 2022 Rank 15
                  </p>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* FAQs Section */}
      <section className="py-12 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Frequently Asked Questions
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Find answers to common questions about our recorded classes.
            </p>
          </div>

          <div className="max-w-3xl mx-auto divide-y divide-gray-200">
            <div className="py-6">
              <h3 className="text-lg font-medium text-gray-900">
                How long will I have access to recorded classes?
              </h3>
              <p className="mt-2 text-gray-600">
                Once you subscribe to our platform or purchase individual
                classes, you'll have lifetime access to those recordings. You
                can watch them as many times as you need.
              </p>
            </div>

            <div className="py-6">
              <h3 className="text-lg font-medium text-gray-900">
                Can I download the class videos for offline viewing?
              </h3>
              <p className="mt-2 text-gray-600">
                No, the class videos are available for streaming only and cannot
                be downloaded. This helps us protect our intellectual property
                and ensures that our content is not distributed without
                permission.
              </p>
            </div>

            <div className="py-6">
              <h3 className="text-lg font-medium text-gray-900">
                Do recorded classes include study materials?
              </h3>
              <p className="mt-2 text-gray-600">
                Yes, most recorded classes come with downloadable study
                materials, including PDF notes, practice questions, and
                reference documents to supplement your learning.
              </p>
            </div>

            <div className="py-6">
              <h3 className="text-lg font-medium text-gray-900">
                How are recorded classes different from live classes?
              </h3>
              <p className="mt-2 text-gray-600">
                Recorded classes offer the flexibility to learn at your own
                pace, while live classes provide real-time interaction with
                instructors. However, our recorded classes are comprehensive and
                include all the content covered in live sessions.
              </p>
            </div>

            <div className="py-6">
              <h3 className="text-lg font-medium text-gray-900">
                Can I ask questions about recorded class content?
              </h3>
              <p className="mt-2 text-gray-600">
                Yes, each recorded class has a discussion forum where you can
                post your questions. Our instructors actively monitor these
                forums and respond promptly to student queries.
              </p>
            </div>

            <div className="py-6">
              <h3 className="text-lg font-medium text-gray-900">
                Are the recorded classes included in subscription plans?
              </h3>
              <p className="mt-2 text-gray-600">
                Yes, all our subscription plans include access to recorded
                classes. The specific number and types of classes available
                depend on your subscription tier.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-16 bg-gradient-to-r from-indigo-900 to-blue-800 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold mb-6">
            Ready to Start Your NPSC Journey?
          </h2>
          <p className="text-xl text-gray-200 mb-8 max-w-3xl mx-auto">
            Join hundreds of successful candidates who transformed their NPSC
            preparation with our comprehensive recorded classes.
          </p>
          <div className="flex flex-col sm:flex-row justify-center space-y-4 sm:space-y-0 sm:space-x-4">
            <Link
              to="/subscribe"
              className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-indigo-900 bg-yellow-400 hover:bg-yellow-500 transition-colors duration-300 shadow-md"
            >
              Subscribe Now
            </Link>
            <Link
              to="/free-trial"
              className="inline-flex items-center justify-center px-6 py-3 border-2 border-white text-base font-medium rounded-md text-white hover:bg-white/10 transition-colors duration-300"
            >
              Try Free Class
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default RecordedClassesPage;


// import React, { useState, useEffect } from "react";
// import { Link, useLocation, useNavigate } from "react-router-dom";
// import { motion } from "framer-motion";
// import axios from "axios";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// // Base URL for API calls
// const API_BASE_URL = "https://server.skysep.in";

// const RecordedClassesPage = () => {
//   const location = useLocation();
//   const navigate = useNavigate();
  
//   // Parse query parameters
//   const queryParams = new URLSearchParams(location.search);
//   const subjectParam = queryParams.get("subject");
//   const typeParam = queryParams.get("type");
//   const searchParam = queryParams.get("search");

//   // State for filters
//   const [searchQuery, setSearchQuery] = useState(searchParam || "");
//   const [subjectFilter, setSubjectFilter] = useState(subjectParam || "all");
//   const [typeFilter, setTypeFilter] = useState(typeParam || "all");
//   const [sortOption, setSortOption] = useState("newest");
//   const [showFilters, setShowFilters] = useState(false);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
  
//   // State for data
//   const [recordedClasses, setRecordedClasses] = useState([]);
//   const [popularClasses, setPopularClasses] = useState([]);
//   const [subjects, setSubjects] = useState([]);
//   const [totalClasses, setTotalClasses] = useState(0);
//   const [totalPages, setTotalPages] = useState(1);
  
//   const classesPerPage = 9;

//   // Scroll to top on mount
//   useEffect(() => {
//     window.scrollTo(0, 0);
//   }, []);

//   // Update URL with filters
//   useEffect(() => {
//     const params = new URLSearchParams();
    
//     if (searchQuery) params.set("search", searchQuery);
//     if (subjectFilter !== "all") params.set("subject", subjectFilter);
//     if (typeFilter !== "all") params.set("type", typeFilter);
    
//     const newUrl = 
//       params.toString() 
//         ? `${location.pathname}?${params.toString()}` 
//         : location.pathname;
    
//     // Update URL without reloading page
//     navigate(newUrl, { replace: true });
//   }, [searchQuery, subjectFilter, typeFilter, location.pathname, navigate]);

//   // Fetch subjects for filter dropdown
//   useEffect(() => {
//     const fetchSubjects = async () => {
//       try {
//         const response = await axios.get(`${API_BASE_URL}/api/subjects`);
//         if (response.data.success) {
//           setSubjects(response.data.subjects);
//         }
//       } catch (error) {
//         console.error("Error fetching subjects:", error);
//       }
//     };

//     fetchSubjects();
//   }, []);

//   // Fetch recorded classes
//   useEffect(() => {
//     const fetchClasses = async () => {
//       setLoading(true);
//       try {
//         // Build query parameters
//         const params = {
//           page: currentPage,
//           limit: classesPerPage,
//           sort: sortOption,
//         };
        
//         if (searchQuery) params.search = searchQuery;
//         if (subjectFilter !== "all") params.subject = subjectFilter;
//         if (typeFilter !== "all") params.type = typeFilter;
        
//         const response = await axios.get(`${API_BASE_URL}/api/recorded-classes/public`, { params });
        
//         if (response.data.success) {
//           setRecordedClasses(response.data.recordedClasses);
//           setPopularClasses(response.data.popularClasses || []);
//           setTotalClasses(response.data.total);
//           setTotalPages(response.data.pages);
//         } else {
//           setError("Failed to fetch classes");
//         }
//       } catch (error) {
//         console.error("Error fetching classes:", error);
//         setError("An error occurred while fetching classes");
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchClasses();
//   }, [currentPage, searchQuery, subjectFilter, typeFilter, sortOption]);

//   // Handle search input
//   const handleSearchSubmit = (e) => {
//     e.preventDefault();
//     setCurrentPage(1); // Reset to first page when searching
//   };

//   // Reset filters
//   const resetFilters = () => {
//     setSearchQuery("");
//     setSubjectFilter("all");
//     setTypeFilter("all");
//     setSortOption("newest");
//     setCurrentPage(1);
//   };

//   // Format date
//   const formatDate = (dateString) => {
//     const options = { year: 'numeric', month: 'long', day: 'numeric' };
//     return new Date(dateString).toLocaleDateString(undefined, options);
//   };

//   return (
//     <div className="pt-20">
//       <ToastContainer position="top-right" autoClose={3000} />
      
//       {/* Hero Section */}
//       <section className="relative bg-gray-900 text-white">
//         <div className="absolute inset-0">
//           <div className="absolute inset-0 bg-gray-900 opacity-90"></div>
//           <div className="absolute inset-0 bg-[url('https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRiqn5jXhC1CTq8isbIwTTte77VL0U7zhlBwQ&s')] opacity-10 bg-cover bg-center"></div>
//         </div>
//         <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
//           <div className="max-w-3xl">
//             <motion.h1
//               className="text-4xl md:text-5xl font-extrabold tracking-tight mb-6"
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.5 }}
//             >
//               NPSC Recorded Classes Library
//             </motion.h1>
//             <motion.p
//               className="text-lg md:text-xl mb-8 text-gray-200"
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.5, delay: 0.1 }}
//             >
//               Access our comprehensive library of high-quality recorded classes.
//               Learn at your own pace with content tailored specifically for NPSC
//               preparation.
//             </motion.p>
//             <motion.div
//               className="relative"
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.5, delay: 0.2 }}
//             >
//               <form onSubmit={handleSearchSubmit}>
//                 <div className="relative">
//                   <input
//                     type="text"
//                     className="block w-full rounded-lg border-0 py-4 pl-12 pr-4 text-gray-900 shadow-md placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm"
//                     placeholder="Search for classes, topics, or instructors..."
//                     value={searchQuery}
//                     onChange={(e) => setSearchQuery(e.target.value)}
//                   />
//                   <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
//                     <svg
//                       className="w-6 h-6 text-gray-500"
//                       fill="none"
//                       stroke="currentColor"
//                       viewBox="0 0 24 24"
//                     >
//                       <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth={2}
//                         d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
//                       />
//                     </svg>
//                   </div>
//                 </div>
//               </form>
//             </motion.div>
//           </div>
//         </div>
//       </section>

//       {/* Main Content */}
//       <section className="py-12 bg-white">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="mb-8 flex flex-col md:flex-row justify-between items-start md:items-center">
//             <h2 className="text-2xl font-bold text-gray-900 mb-4 md:mb-0">
//               {loading ? "Loading classes..." : `${totalClasses} Classes Available`}
//             </h2>
//             <div className="flex flex-col sm:flex-row space-y-3 sm:space-y-0 sm:space-x-3">
//               <button
//                 onClick={() => setShowFilters(!showFilters)}
//                 className="inline-flex items-center justify-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50"
//               >
//                 <svg
//                   className="w-4 h-4 mr-2"
//                   fill="none"
//                   stroke="currentColor"
//                   viewBox="0 0 24 24"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"
//                   />
//                 </svg>
//                 {showFilters ? "Hide Filters" : "Show Filters"}
//               </button>
//               <div className="flex items-center space-x-2">
//                 <label
//                   htmlFor="sort"
//                   className="text-sm font-medium text-gray-700"
//                 >
//                   Sort by:
//                 </label>
//                 <select
//                   id="sort"
//                   className="block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
//                   value={sortOption}
//                   onChange={(e) => setSortOption(e.target.value)}
//                 >
//                   <option value="newest">Newest First</option>
//                   <option value="oldest">Oldest First</option>
//                   <option value="rating">Highest Rated</option>
//                   <option value="popularity">Most Viewed</option>
//                   <option value="duration-asc">Shortest First</option>
//                   <option value="duration-desc">Longest First</option>
//                 </select>
//               </div>
//             </div>
//           </div>

//           {/* Filters Panel */}
//           {showFilters && (
//             <motion.div
//               initial={{ opacity: 0, height: 0 }}
//               animate={{ opacity: 1, height: "auto" }}
//               exit={{ opacity: 0, height: 0 }}
//               transition={{ duration: 0.3 }}
//               className="bg-gray-50 rounded-lg p-6 mb-8"
//             >
//               <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
//                 <div>
//                   <label
//                     htmlFor="subject-filter"
//                     className="block text-sm font-medium text-gray-700 mb-1"
//                   >
//                     Filter by Subject
//                   </label>
//                   <select
//                     id="subject-filter"
//                     className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
//                     value={subjectFilter}
//                     onChange={(e) => {
//                       setSubjectFilter(e.target.value);
//                       setCurrentPage(1); // Reset to first page when filtering
//                     }}
//                   >
//                     <option value="all">All Subjects</option>
//                     {subjects.map((subject) => (
//                       <option key={subject} value={subject}>
//                         {subject}
//                       </option>
//                     ))}
//                   </select>
//                 </div>
//                 <div>
//                   <label
//                     htmlFor="type-filter"
//                     className="block text-sm font-medium text-gray-700 mb-1"
//                   >
//                     Filter by Level
//                   </label>
//                   <select
//                     id="type-filter"
//                     className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
//                     value={typeFilter}
//                     onChange={(e) => {
//                       setTypeFilter(e.target.value);
//                       setCurrentPage(1); // Reset to first page when filtering
//                     }}
//                   >
//                     <option value="all">All Levels</option>
//                     <option value="foundation">Foundation</option>
//                     <option value="prelims">Prelims</option>
//                     <option value="mains">Mains</option>
//                   </select>
//                 </div>
//                 <div className="lg:col-span-2">
//                   <label className="block text-sm font-medium text-gray-700 mb-1">
//                     Quick Filters
//                   </label>
//                   <div className="flex flex-wrap gap-2">
//                     <button
//                       onClick={() => {
//                         setTypeFilter("foundation");
//                         setSortOption("newest");
//                         setCurrentPage(1);
//                       }}
//                       className="inline-flex items-center px-3 py-1.5 border border-gray-300 rounded-full text-xs font-medium bg-white text-gray-700 hover:bg-gray-50"
//                     >
//                       Foundation Classes
//                     </button>
//                     <button
//                       onClick={() => {
//                         setSortOption("rating");
//                         setCurrentPage(1);
//                       }}
//                       className="inline-flex items-center px-3 py-1.5 border border-gray-300 rounded-full text-xs font-medium bg-white text-gray-700 hover:bg-gray-50"
//                     >
//                       Top Rated
//                     </button>
//                     <button
//                       onClick={() => {
//                         setSortOption("popularity");
//                         setCurrentPage(1);
//                       }}
//                       className="inline-flex items-center px-3 py-1.5 border border-gray-300 rounded-full text-xs font-medium bg-white text-gray-700 hover:bg-gray-50"
//                     >
//                       Most Popular
//                     </button>
//                     <button
//                       onClick={() => {
//                         setTypeFilter("prelims");
//                         setCurrentPage(1);
//                       }}
//                       className="inline-flex items-center px-3 py-1.5 border border-gray-300 rounded-full text-xs font-medium bg-white text-gray-700 hover:bg-gray-50"
//                     >
//                       Prelims Focus
//                     </button>
//                     <button
//                       onClick={() => {
//                         setTypeFilter("mains");
//                         setCurrentPage(1);
//                       }}
//                       className="inline-flex items-center px-3 py-1.5 border border-gray-300 rounded-full text-xs font-medium bg-white text-gray-700 hover:bg-gray-50"
//                     >
//                       Mains Focus
//                     </button>
//                     {subjects.includes("Exam Strategy") && (
//                       <button
//                         onClick={() => {
//                           setSubjectFilter("Exam Strategy");
//                           setCurrentPage(1);
//                         }}
//                         className="inline-flex items-center px-3 py-1.5 border border-gray-300 rounded-full text-xs font-medium bg-white text-gray-700 hover:bg-gray-50"
//                       >
//                         Exam Strategy
//                       </button>
//                     )}
//                   </div>
//                 </div>
//               </div>
//               <div className="mt-4 flex justify-end">
//                 <button
//                   onClick={resetFilters}
//                   className="text-sm text-indigo-600 hover:text-indigo-800 font-medium"
//                 >
//                   Reset All Filters
//                 </button>
//               </div>
//             </motion.div>
//           )}

//           {/* Popular Classes (only shown when no filters are applied) */}
//           {!searchQuery && subjectFilter === "all" && typeFilter === "all" && popularClasses.length > 0 && (
//             <div className="mb-12">
//               <h2 className="text-2xl font-bold text-gray-900 mb-6">
//                 Popular Classes
//               </h2>
//               <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
//                 {popularClasses.map((popularClass) => (
//                   <motion.div
//                     key={popularClass._id}
//                     initial={{ opacity: 0, y: 20 }}
//                     animate={{ opacity: 1, y: 0 }}
//                     transition={{ duration: 0.3 }}
//                     className="bg-white border border-gray-200 rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-all duration-300"
//                   >
//                     <div className="relative">
//                       <img
//                         src={
//                           popularClass.image
//                             ? `${API_BASE_URL}${popularClass.image}`
//                             : "/images/placeholder.jpg"
//                         }
//                         alt={popularClass.title}
//                         className="w-full h-40 object-cover"
//                         onError={(e) => {
//                           e.target.src = "/images/placeholder.jpg";
//                         }}
//                       />
//                       <div className="absolute inset-0 flex items-center justify-center">
//                         <div className="w-12 h-12 bg-white/80 rounded-full flex items-center justify-center">
//                           <svg
//                             className="w-6 h-6 text-indigo-600"
//                             fill="currentColor"
//                             viewBox="0 0 20 20"
//                           >
//                             <path d="M4 5h3v10H4V5zm12 0v10l-9-5 9-5z" />
//                           </svg>
//                         </div>
//                       </div>
//                       <div className="absolute top-0 right-0 m-2">
//                         <span className="bg-yellow-100 text-yellow-800 text-xs font-medium px-2.5 py-0.5 rounded-full">
//                           Popular
//                         </span>
//                       </div>
//                       <div className="absolute bottom-0 left-0 m-2">
//                         <span className="bg-black/60 text-white text-xs font-medium px-2.5 py-0.5 rounded">
//                           {popularClass.duration}
//                         </span>
//                       </div>
//                     </div>
//                     <div className="p-4">
//                       <div className="flex justify-between mb-1">
//                         <span
//                           className={`text-xs font-medium px-2 py-0.5 rounded ${
//                             popularClass.type === "foundation"
//                               ? "bg-green-100 text-green-800"
//                               : popularClass.type === "prelims"
//                               ? "bg-blue-100 text-blue-800"
//                               : "bg-purple-100 text-purple-800"
//                           }`}
//                         >
//                           {popularClass.type.charAt(0).toUpperCase() +
//                             popularClass.type.slice(1)}
//                         </span>
//                         <div className="flex items-center">
//                           <svg
//                             className="w-4 h-4 text-yellow-400"
//                             fill="currentColor"
//                             viewBox="0 0 20 20"
//                           >
//                             <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
//                           </svg>
//                           <span className="text-xs ml-1 text-gray-600">
//                             {popularClass.rating}
//                           </span>
//                         </div>
//                       </div>
//                       <h3 className="text-lg font-bold text-gray-900 mb-1 line-clamp-1">
//                         {popularClass.title}
//                       </h3>
//                       <p className="text-sm text-gray-600 mb-2">
//                         {popularClass.instructor}
//                       </p>
//                       <Link
//                         to={`/class-details/${popularClass._id}`}
//                         className="text-indigo-600 hover:text-indigo-800 text-sm font-medium flex items-center"
//                       >
//                         <span>Watch Now</span>
//                         <svg
//                           className="w-4 h-4 ml-1"
//                           fill="none"
//                           stroke="currentColor"
//                           viewBox="0 0 24 24"
//                         >
//                           <path
//                             strokeLinecap="round"
//                             strokeLinejoin="round"
//                             strokeWidth={2}
//                             d="M17 8l4 4m0 0l-4 4m4-4H3"
//                           />
//                         </svg>
//                       </Link>
//                     </div>
//                   </motion.div>
//                 ))}
//               </div>
//             </div>
//           )}

//           {/* Loading State */}
//           {loading && (
//             <div className="flex justify-center items-center py-20">
//               <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-indigo-600"></div>
//             </div>
//           )}

//           {/* Error State */}
//           {error && !loading && (
//             <div className="text-center py-10">
//               <svg
//                 className="mx-auto h-12 w-12 text-red-400"
//                 fill="none"
//                 stroke="currentColor"
//                 viewBox="0 0 24 24"
//               >
//                 <path
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                   strokeWidth={2}
//                   d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
//                 />
//               </svg>
//               <h3 className="mt-3 text-xl font-medium text-gray-900">Error</h3>
//               <p className="mt-2 text-gray-500">{error}</p>
//               <button
//                 onClick={() => window.location.reload()}
//                 className="mt-4 inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700"
//               >
//                 Retry
//               </button>
//             </div>
//           )}

//           {/* Classes Grid */}
//           {!loading && !error && recordedClasses.length === 0 ? (
//             <div className="text-center py-16">
//               <svg
//                 className="w-16 h-16 text-gray-300 mx-auto mb-4"
//                 fill="none"
//                 stroke="currentColor"
//                 viewBox="0 0 24 24"
//               >
//                 <path
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                   strokeWidth={2}
//                   d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z"
//                 />
//               </svg>
//               <h3 className="text-lg font-medium text-gray-900 mb-1">
//                 No classes found
//               </h3>
//               <p className="text-gray-600 mb-4">
//                 Try adjusting your search or filter criteria
//               </p>
//               <button
//                 onClick={resetFilters}
//                 className="inline-flex items-center justify-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700"
//               >
//                 Reset Filters
//               </button>
//             </div>
//           ) : (
//             !loading && !error && (
//               <>
//                 <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
//                   {recordedClasses.map((recordedClass) => (
//                     <motion.div
//                       key={recordedClass._id}
//                       initial={{ opacity: 0, y: 20 }}
//                       animate={{ opacity: 1, y: 0 }}
//                       transition={{ duration: 0.3 }}
//                       className="bg-white border border-gray-200 rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-all duration-300"
//                     >
//                       <div className="relative">
//                         <img
//                           src={
//                             recordedClass.image
//                               ? `${API_BASE_URL}${recordedClass.image}`
//                               : "/images/placeholder.jpg"
//                           }
//                           alt={recordedClass.title}
//                           className="w-full h-48 object-cover"
//                           onError={(e) => {
//                             e.target.src = "/images/placeholder.jpg";
//                           }}
//                         />
//                         <div className="absolute inset-0 flex items-center justify-center">
//                           <div className="w-14 h-14 bg-white/80 rounded-full flex items-center justify-center">
//                             <svg
//                               className="w-8 h-8 text-indigo-600"
//                               fill="currentColor"
//                               viewBox="0 0 20 20"
//                             >
//                               <path d="M4 5h3v10H4V5zm12 0v10l-9-5 9-5z" />
//                             </svg>
//                           </div>
//                         </div>
//                         <div className="absolute top-2 right-2 flex space-x-2">
//                           <span className="bg-indigo-100 text-indigo-800 text-xs font-medium px-2.5 py-0.5 rounded">
//                             {recordedClass.subject}
//                           </span>
//                           {recordedClass.popular && (
//                             <span className="bg-yellow-100 text-yellow-800 text-xs font-medium px-2.5 py-0.5 rounded-full">
//                               Popular
//                             </span>
//                           )}
//                         </div>
//                         <div className="absolute bottom-2 left-2 bg-black/60 text-white text-xs font-medium px-2.5 py-0.5 rounded">
//                           {recordedClass.duration}
//                         </div>
//                       </div>
//                       <div className="p-5">
//                         <div className="flex justify-between items-center mb-2">
//                           <span
//                             className={`text-xs font-medium px-2.5 py-0.5 rounded ${
//                               recordedClass.type === "foundation"
//                                 ? "bg-green-100 text-green-800"
//                                 : recordedClass.type === "prelims"
//                                 ? "bg-blue-100 text-blue-800"
//                                 : "bg-purple-100 text-purple-800"
//                             }`}
//                           >
//                             {recordedClass.type.charAt(0).toUpperCase() +
//                               recordedClass.type.slice(1)}
//                           </span>
//                           <div className="flex items-center">
//                             <svg
//                               className="w-4 h-4 text-yellow-400"
//                               fill="currentColor"
//                               viewBox="0 0 20 20"
//                             >
//                               <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
//                             </svg>
//                             <span className="text-xs ml-1 text-gray-600">
//                               {recordedClass.rating}
//                             </span>
//                           </div>
//                         </div>
//                         <h3 className="text-lg font-bold text-gray-900 mb-2">
//                           {recordedClass.title}
//                         </h3>
//                         <p className="text-gray-600 text-sm mb-4 line-clamp-2">
//                           {recordedClass.description}
//                         </p>
//                         <div className="flex items-center mb-4">
//                         <svg
//                             className="w-4 h-4 mr-1 text-gray-600"
//                             fill="none"
//                             stroke="currentColor"
//                             viewBox="0 0 24 24"
//                           >
//                             <path
//                               strokeLinecap="round"
//                               strokeLinejoin="round"
//                               strokeWidth={2}
//                               d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
//                             />
//                           </svg>
//                           <p className="text-sm text-gray-700">
//                             {recordedClass.instructor}
//                           </p>
//                         </div>
//                         <div className="flex justify-between items-center">
//                           <div className="flex items-center text-xs text-gray-500">
//                             <svg
//                               className="w-4 h-4 mr-1"
//                               fill="none"
//                               stroke="currentColor"
//                               viewBox="0 0 24 24"
//                             >
//                               <path
//                                 strokeLinecap="round"
//                                 strokeLinejoin="round"
//                                 strokeWidth={2}
//                                 d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
//                               />
//                               <path
//                                 strokeLinecap="round"
//                                 strokeLinejoin="round"
//                                 strokeWidth={2}
//                                 d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
//                               />
//                             </svg>
//                             <span>{recordedClass.views} views</span>
//                           </div>
//                           <Link
//                             to={`/class-details/${recordedClass._id}`}
//                             className="inline-flex items-center text-indigo-600 hover:text-indigo-800 font-medium"
//                           >
//                             <span>Watch Now</span>
//                             <svg
//                               className="w-4 h-4 ml-1"
//                               fill="none"
//                               stroke="currentColor"
//                               viewBox="0 0 24 24"
//                             >
//                               <path
//                                 strokeLinecap="round"
//                                 strokeLinejoin="round"
//                                 strokeWidth={2}
//                                 d="M17 8l4 4m0 0l-4 4m4-4H3"
//                               />
//                             </svg>
//                           </Link>
//                         </div>
//                       </div>
//                     </motion.div>
//                   ))}
//                 </div>

//                 {/* Pagination */}
//                 {totalPages > 1 && (
//                   <div className="flex justify-center mt-10">
//                     <nav className="flex items-center space-x-1">
//                       <button
//                         onClick={() =>
//                           setCurrentPage((prev) => Math.max(prev - 1, 1))
//                         }
//                         disabled={currentPage === 1}
//                         className={`px-3 py-2 rounded-md text-sm font-medium ${
//                           currentPage === 1
//                             ? "text-gray-400 cursor-not-allowed"
//                             : "text-gray-500 bg-white border border-gray-300 hover:bg-gray-50"
//                         }`}
//                       >
//                         Previous
//                       </button>

//                       {/* Dynamic pagination buttons */}
//                       {Array.from({ length: Math.min(5, totalPages) }).map((_, i) => {
//                         // Calculate the page number to display based on current page
//                         let pageNumber;
//                         if (totalPages <= 5) {
//                           // If there are 5 or fewer pages, just show them all
//                           pageNumber = i + 1;
//                         } else if (currentPage <= 3) {
//                           // If we're near the start, show pages 1-5
//                           pageNumber = i + 1;
//                         } else if (currentPage >= totalPages - 2) {
//                           // If we're near the end, show the last 5 pages
//                           pageNumber = totalPages - 4 + i;
//                         } else {
//                           // Otherwise, show 2 pages before and 2 pages after current page
//                           pageNumber = currentPage - 2 + i;
//                         }

//                         return (
//                           <button
//                             key={pageNumber}
//                             onClick={() => setCurrentPage(pageNumber)}
//                             className={`px-3 py-2 rounded-md text-sm font-medium ${
//                               currentPage === pageNumber
//                                 ? "text-white bg-indigo-600 border border-indigo-600"
//                                 : "text-gray-700 bg-white border border-gray-300 hover:bg-gray-50"
//                             }`}
//                           >
//                             {pageNumber}
//                           </button>
//                         );
//                       })}

//                       <button
//                         onClick={() =>
//                           setCurrentPage((prev) => Math.min(prev + 1, totalPages))
//                         }
//                         disabled={currentPage === totalPages}
//                         className={`px-3 py-2 rounded-md text-sm font-medium ${
//                           currentPage === totalPages
//                             ? "text-gray-400 cursor-not-allowed"
//                             : "text-gray-700 bg-white border border-gray-300 hover:bg-gray-50"
//                         }`}
//                       >
//                         Next
//                       </button>
//                     </nav>
//                   </div>
//                 )}
//               </>
//             )
//           )}
//         </div>
//       </section>

//       {/* Subject Categories Section */}
//       <section className="py-12 bg-gray-50">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center">
//             Browse by Subject
//           </h2>

//           <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
//             {/* Dynamic subject categories - show first 4 subjects or placeholders */}
//             {subjects.length > 0 ? (
//               subjects.slice(0, 4).map((subject, index) => (
//                 <Link
//                   key={subject}
//                   to={`/recorded-classes?subject=${subject}`}
//                   className="group flex flex-col items-center p-6 bg-white rounded-lg shadow-md hover:shadow-lg transition-all duration-300"
//                 >
//                   <div className="w-16 h-16 bg-indigo-100 rounded-full flex items-center justify-center mb-4 group-hover:bg-indigo-200 transition-colors duration-300">
//                     {/* Different icon for each subject - using index to select */}
//                     {index === 0 && (
//                       <svg
//                         className="w-8 h-8 text-indigo-600"
//                         fill="none"
//                         stroke="currentColor"
//                         viewBox="0 0 24 24"
//                       >
//                         <path
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                           strokeWidth={2}
//                           d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"
//                         />
//                       </svg>
//                     )}
//                     {index === 1 && (
//                       <svg
//                         className="w-8 h-8 text-indigo-600"
//                         fill="none"
//                         stroke="currentColor"
//                         viewBox="0 0 24 24"
//                       >
//                         <path
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                           strokeWidth={2}
//                           d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
//                         />
//                       </svg>
//                     )}
//                     {index === 2 && (
//                       <svg
//                         className="w-8 h-8 text-indigo-600"
//                         fill="none"
//                         stroke="currentColor"
//                         viewBox="0 0 24 24"
//                       >
//                         <path
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                           strokeWidth={2}
//                           d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
//                         />
//                       </svg>
//                     )}
//                     {index === 3 && (
//                       <svg
//                         className="w-8 h-8 text-indigo-600"
//                         fill="none"
//                         stroke="currentColor"
//                         viewBox="0 0 24 24"
//                       >
//                         <path
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                           strokeWidth={2}
//                           d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"
//                         />
//                       </svg>
//                     )}
//                   </div>
//                   <h3 className="text-xl font-bold text-gray-900 mb-2">{subject}</h3>
//                   <p className="text-gray-600 text-center mb-4">
//                     {/* Dynamic description based on subject */}
//                     {subject.includes("History") && "Historical evolution, key events, and movements"}
//                     {subject.includes("Admin") && "Governance structures, policies, and administrative systems"}
//                     {subject.includes("Culture") && "Tribal traditions, festivals, arts, and cultural heritage"}
//                     {subject.includes("Exam") && "Preparation techniques, answer writing, and exam approach"}
//                     {!subject.includes("History") && !subject.includes("Admin") && 
//                      !subject.includes("Culture") && !subject.includes("Exam") && 
//                      `Courses related to ${subject} for NPSC preparation`}
//                   </p>
//                   <span className="text-indigo-600 font-medium flex items-center group-hover:text-indigo-800">
//                     View Classes
//                     <svg
//                       className="w-4 h-4 ml-1 transform group-hover:translate-x-1 transition-transform duration-300"
//                       fill="none"
//                       stroke="currentColor"
//                       viewBox="0 0 24 24"
//                     >
//                       <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth={2}
//                         d="M17 8l4 4m0 0l-4 4m4-4H3"
//                       />
//                     </svg>
//                   </span>
//                 </Link>
//               ))
//             ) : (
//               // Placeholder for when subjects are loading
//               Array.from({ length: 4 }).map((_, index) => (
//                 <div 
//                   key={index}
//                   className="flex flex-col items-center p-6 bg-white rounded-lg shadow-md"
//                 >
//                   <div className="w-16 h-16 bg-gray-200 rounded-full mb-4 animate-pulse"></div>
//                   <div className="h-6 bg-gray-200 rounded w-24 mb-2 animate-pulse"></div>
//                   <div className="h-4 bg-gray-200 rounded w-32 mb-2 animate-pulse"></div>
//                   <div className="h-4 bg-gray-200 rounded w-28 mb-4 animate-pulse"></div>
//                   <div className="h-4 bg-gray-200 rounded w-20 animate-pulse"></div>
//                 </div>
//               ))
//             )}
//           </div>

//           {subjects.length > 4 && (
//             <div className="text-center mt-8">
//               <Link
//                 to="/subjects"
//                 className="inline-flex items-center text-indigo-600 hover:text-indigo-800 font-medium"
//               >
//                 <span>View All Subjects</span>
//                 <svg
//                   className="w-4 h-4 ml-1"
//                   fill="none"
//                   stroke="currentColor"
//                   viewBox="0 0 24 24"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M17 8l4 4m0 0l-4 4m4-4H3"
//                   />
//                 </svg>
//               </Link>
//             </div>
//           )}
//         </div>
//       </section>

//       {/* Study Plans Section */}
//       <section className="py-12 bg-white">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="text-center mb-12">
//             <h2 className="text-3xl font-bold text-gray-900 mb-4">
//               Curated Study Plans
//             </h2>
//             <p className="text-lg text-gray-600 max-w-3xl mx-auto">
//               Follow our expert-designed learning paths to efficiently prepare
//               for different stages of the NPSC examination.
//             </p>
//           </div>

//           <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
//             <div className="bg-white border border-gray-200 rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-all duration-300">
//               <div className="h-3 bg-green-500"></div>
//               <div className="p-6">
//                 <h3 className="text-xl font-bold text-gray-900 mb-2">
//                   Foundation Course
//                 </h3>
//                 <p className="text-gray-600 mb-4">
//                   Build a strong foundation with essential concepts and
//                   knowledge areas for NPSC preparation.
//                 </p>
//                 <div className="flex items-center mb-4">
//                   <svg
//                     className="w-5 h-5 text-gray-500 mr-2"
//                     fill="none"
//                     stroke="currentColor"
//                     viewBox="0 0 24 24"
//                   >
//                     <path
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       strokeWidth={2}
//                       d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
//                     />
//                   </svg>
//                   <span className="text-gray-600">48 hours of content</span>
//                 </div>
//                 <div className="flex items-center mb-4">
//                   <svg
//                     className="w-5 h-5 text-gray-500 mr-2"
//                     fill="none"
//                     stroke="currentColor"
//                     viewBox="0 0 24 24"
//                   >
//                     <path
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       strokeWidth={2}
//                       d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"
//                     />
//                   </svg>
//                   <span className="text-gray-600">Ideal for beginners</span>
//                 </div>
//                 <div className="flex items-center mb-6">
//                   <svg
//                     className="w-5 h-5 text-gray-500 mr-2"
//                     fill="none"
//                     stroke="currentColor"
//                     viewBox="0 0 24 24"
//                   >
//                     <path
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       strokeWidth={2}
//                       d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"
//                     />
//                   </svg>
//                   <span className="text-gray-600">16 curated classes</span>
//                 </div>
//                 <Link
//                   to="/study-plan/foundation"
//                   className="block w-full text-center py-3 bg-green-600 hover:bg-green-700 text-white font-medium rounded-md transition-colors duration-300"
//                 >
//                   View Study Plan
//                 </Link>
//               </div>
//             </div>

//             <div className="bg-white border border-gray-200 rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-all duration-300">
//               <div className="h-3 bg-blue-500"></div>
//               <div className="p-6">
//                 <h3 className="text-xl font-bold text-gray-900 mb-2">
//                   Prelims Preparation
//                 </h3>
//                 <p className="text-gray-600 mb-4">
//                   Focused preparation for NPSC Preliminary examination with
//                   subject-specific content and strategies.
//                 </p>
//                 <div className="flex items-center mb-4">
//                   <svg
//                     className="w-5 h-5 text-gray-500 mr-2"
//                     fill="none"
//                     stroke="currentColor"
//                     viewBox="0 0 24 24"
//                   >
//                     <path
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       strokeWidth={2}
//                       d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
//                     />
//                   </svg>
//                   <span className="text-gray-600">64 hours of content</span>
//                 </div>
//                 <div className="flex items-center mb-4">
//                   <svg
//                     className="w-5 h-5 text-gray-500 mr-2"
//                     fill="none"
//                     stroke="currentColor"
//                     viewBox="0 0 24 24"
//                   >
//                     <path
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       strokeWidth={2}
//                       d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"
//                     />
//                   </svg>
//                   <span className="text-gray-600">Includes MCQ practice</span>
//                 </div>
//                 <div className="flex items-center mb-6">
//                   <svg
//                     className="w-5 h-5 text-gray-500 mr-2"
//                     fill="none"
//                     stroke="currentColor"
//                     viewBox="0 0 24 24"
//                   >
//                     <path
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       strokeWidth={2}
//                       d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"
//                     />
//                   </svg>
//                   <span className="text-gray-600">24 curated classes</span>
//                 </div>
//                 <Link
//                   to="/study-plan/prelims"
//                   className="block w-full text-center py-3 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-md transition-colors duration-300"
//                 >
//                   View Study Plan
//                 </Link>
//               </div>
//             </div>

//             <div className="bg-white border border-gray-200 rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-all duration-300">
//               <div className="h-3 bg-purple-500"></div>
//               <div className="p-6">
//                 <h3 className="text-xl font-bold text-gray-900 mb-2">
//                   Mains Mastery
//                 </h3>
//                 <p className="text-gray-600 mb-4">
//                   Comprehensive preparation for NPSC Mains examination with
//                   emphasis on answer writing and analytical skills.
//                 </p>
//                 <div className="flex items-center mb-4">
//                   <svg
//                     className="w-5 h-5 text-gray-500 mr-2"
//                     fill="none"
//                     stroke="currentColor"
//                     viewBox="0 0 24 24"
//                   >
//                     <path
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       strokeWidth={2}
//                       d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
//                     />
//                   </svg>
//                   <span className="text-gray-600">72 hours of content</span>
//                 </div>
//                 <div className="flex items-center mb-4">
//                   <svg
//                     className="w-5 h-5 text-gray-500 mr-2"
//                     fill="none"
//                     stroke="currentColor"
//                     viewBox="0 0 24 24"
//                   >
//                     <path
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       strokeWidth={2}
//                       d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"
//                     />
//                   </svg>
//                   <span className="text-gray-600">Answer writing focus</span>
//                 </div>
//                 <div className="flex items-center mb-6">
//                   <svg
//                     className="w-5 h-5 text-gray-500 mr-2"
//                     fill="none"
//                     stroke="currentColor"
//                     viewBox="0 0 24 24"
//                   >
//                     <path
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       strokeWidth={2}
//                       d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"
//                     />
//                   </svg>
//                   <span className="text-gray-600">30 curated classes</span>
//                 </div>
//                 <Link
//                   to="/study-plan/mains"
//                   className="block w-full text-center py-3 bg-purple-600 hover:bg-purple-700 text-white font-medium rounded-md transition-colors duration-300"
//                 >
//                   View Study Plan
//                 </Link>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Call to Action */}
//       <section className="py-16 bg-gradient-to-r from-indigo-900 to-blue-800 text-white">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
//           <h2 className="text-3xl font-bold mb-6">
//             Ready to Start Your NPSC Journey?
//           </h2>
//           <p className="text-xl text-gray-200 mb-8 max-w-3xl mx-auto">
//             Join hundreds of successful candidates who transformed their NPSC
//             preparation with our comprehensive recorded classes.
//           </p>
//           <div className="flex flex-col sm:flex-row justify-center space-y-4 sm:space-y-0 sm:space-x-4">
//             <Link
//               to="/subscribe"
//               className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-indigo-900 bg-yellow-400 hover:bg-yellow-500 transition-colors duration-300 shadow-md"
//             >
//               Subscribe Now
//             </Link>
//             <Link
//               to="/free-trial"
//               className="inline-flex items-center justify-center px-6 py-3 border-2 border-white text-base font-medium rounded-md text-white hover:bg-white/10 transition-colors duration-300"
//             >
//               Try Free Class
//             </Link>
//           </div>
//         </div>
//       </section>

//       {/* Class Details Page Component */}
//       {/* This would be a separate component - just adding a placeholder mention here to complete the flow */}
//     </div>
//   );
// };

// export default RecordedClassesPage;